export const en = {
    'empty-gallery-message': 'Nothing found',
    'preview-error': 'An error occurred while loading the preview data. Please try again later.',
    'remove-item-confirmation': 'Are you sure you want to remove the file "{name}"?'
};
